module.exports = __webpack_public_path__ + "img/verified-user.e75b871c.svg";